<div class="placeholder" *cdkDragPlaceholder></div>
<div>
    <ng-content/>
</div>
<div class="actions">
    <ng-content select="[actions]"/>
    <mat-icon class="handle" cdkDragHandle>drag_indicator</mat-icon>
</div>